import Chart from 'chart.js';

// Config.
import { theme } from '../../config';

// Utils.
import { formatAsCurrency } from '../../utils';

//------------------------------------------------------------------------------

Chart.plugins.register({
  afterDatasetsDraw(chart) {
    const ctx = chart.ctx;
    chart.data.datasets.forEach((dataset, i) => {
      const meta = chart.getDatasetMeta(i);
      if (!meta.hidden) {
        meta.data.forEach((element, index) => {
          const fontSize = 12;
          const fontStyle = 'normal';
          const fontFamily = theme.fontFamily.roman;
          ctx.fillStyle = theme.colors.default;
          ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
          ctx.textAlign = 'start';
          ctx.textBaseline = 'middle';
          const padding = 7;
          const position = element.tooltipPosition();
          const dataString = formatAsCurrency(dataset.data[index]);
          ctx.fillText(dataString, position.x + padding, position.y);
        });
      }
    });
  },
});



// WEBPACK FOOTER //
// ./src/components/Chart/chartPluginsRegister.js